function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "compass");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "compass",
  transform: "translate(0.296875, 0.500000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.6132805,10.6289065 C10.9816396,10.2632427 10.9816396,9.66835976 10.6132805,9.30234432 C10.2495694,8.93660188 9.65468645,8.93660188 9.29101467,9.30234432 C8.9225769,9.66808677 8.9225769,10.2628911 9.29101467,10.6289065 C9.65624928,11.0273433 10.2499998,11.0273433 10.6132805,10.6289065 Z M13.9023435,5 C13.8191009,5 13.7312889,5.01426578 13.6480463,5.04296899 L7.7343744,7.17578173 C7.44781196,7.28078127 7.23046839,7.49546885 7.12890565,7.77695298 L4.99804616,13.6910152 C4.78124976,14.289062 5.3906244,15 6.00390553,15 C6.09171808,15 6.17496014,14.9856567 6.25812411,14.957031 L12.1760929,12.8242183 C12.4580848,12.7192187 12.6753116,12.5045311 12.7768743,12.2183585 L14.9077332,6.30820274 C15.1249993,5.71093798 14.515624,5 13.9023435,5 Z M11.640625,11.6875005 L6.36328101,13.5894537 L8.26445282,8.31210971 L13.5417962,6.40781283 L11.640625,11.6875005 Z M10,0 C4.47656274,0 0,4.47656274 0,10 C0,15.5234373 4.47656274,20 10,20 C15.5234373,20 20,15.5234373 20,10 C20,4.47656274 15.5234373,0 10,0 Z M10,18.75 C5.17578125,18.75 1.25,14.8242188 1.25,10 C1.25,5.17578125 5.17578125,1.25 10,1.25 C14.8242188,1.25 18.75,5.17578125 18.75,10 C18.75,14.8242188 14.8242188,18.75 10,18.75 Z",
  id: "Shape"
})));
const SvgIconCompass = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCompass, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-compass.aa5e5b5f.svg";
export { ForwardRef as ReactComponent };